import { Lightbulb } from "lucide-react"
import { useTranslation } from "react-i18next"

/**
 * OKS-396 — Coaching tip strip inside the kudo composer (UX Spec §2.A).
 *
 * A light, muted one-line nudge ("name the specific thing they did well")
 * that makes recognition land. Custom component (NOT under `/ui`); built
 * from muted Tailwind surface + a lucide icon rather than the full `Card`
 * chrome so it reads as an inline hint, not a second card.
 *
 * Purely presentational — no props, copy via i18n.
 *
 * Locked testid: `kudo-tip`.
 */
export function KudoTipCard() {
  const { t } = useTranslation()

  return (
    <p
      data-testid="kudo-tip"
      className="text-muted-foreground bg-muted/40 flex items-start gap-2 rounded-md border p-3 text-xs"
    >
      <Lightbulb className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{t("crew.detail.kudos.tip")}</span>
    </p>
  )
}
